import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import { ErrorHandler, NgModule, LOCALE_ID } from '@angular/core';
import localeIt from '@angular/common/locales/it';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { createTranslateLoader } from './utils/translate-module';
import { MyApp } from './app.component';
import { CoreModule } from './core/core.module';
import { HomePageModule } from '../pages/home/home.module';
import { LoaderService } from './services/loader/loader.service';


registerLocaleData(localeIt);

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    CoreModule,
    HomePageModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {provide: LOCALE_ID, useValue: "it"},
    HttpClient,
    LoaderService,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts